export default __webpack_public_path__ + "static/media/step2.72db4949.webp";